import { http } from '@noor/api';
import { env } from '@noor/config';
import { cuisineSchema, type Cuisine, type CuisineInput } from '../model/cuisine';
import { listItems } from './envelope';

const path = '/api/v1/admin/cuisines';
const options = { baseURL: env.VITE_EATS_API_URL };

export const cuisineApi = {
  async list(): Promise<Cuisine[]> {
    const raw = await http.get<unknown>(path, options);
    return listItems(raw).map((item) => cuisineSchema.parse(item));
  },
  async create(input: CuisineInput): Promise<void> {
    await http.post<unknown>(path, input, options);
  },
  async update(id: string, input: CuisineInput): Promise<void> {
    await http.patch<unknown>(`${path}/${id}`, input, options);
  },
  async remove(id: string): Promise<void> {
    await http.delete<unknown>(`${path}/${id}`, options);
  },
};
